import axios from "axios";
window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

import _ from "lodash";
window._ = _;

import flatpickr from "flatpickr";
import { Czech } from "flatpickr/dist/l10n/cs.js";

window.flatpickr = flatpickr;
window.flatpickr.localize(Czech);

import { lightbox } from "./embed";
window.lightbox = lightbox;
window.adobe_sdk_cid = import.meta.env.VITE_ADOBE_SDK_CID;
